module.exports = __webpack_public_path__ + "static/img/layer10.2f494590.png";